import { deTranslations } from './de';
import { enTranslations } from './en';

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- We need interface merging here
    interface CustomTypeOptions {
        defaultNS: 'custom';
        // half-strict types: we don't check the keys for now; only NS
        resources: Record<TranslationNamespace, Record<string, string>>;
    }
}

export type TranslationNamespace = keyof typeof deTranslations;

export const resources = {
    de: deTranslations,
    en: enTranslations,
};
